import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
import { AppStateFacade } from '@app-state';
var LogService = /** @class */ (function (_super) {
    tslib_1.__extends(LogService, _super);
    function LogService(http, _a) {
        var authConfig = _a.authConfig;
        var _this = _super.call(this, http, MapperService.logMap) || this;
        _this._endpoint = authConfig.odataBaseUrl + "/RobotLogs";
        _this.reportsUrl = _this._endpoint + "/UiPath.Server.Configuration.OData.Reports";
        _this._realGridCountUrl = _this._endpoint + "/UiPath.Server.Configuration.OData.GetTotalCount";
        return _this;
    }
    LogService.prototype.getRealCount = function (queryOptions) {
        return this._http.get("" + this._realGridCountUrl + this.getQueryString(queryOptions))
            .pipe(map(function (response) { return response.value; }));
    };
    return LogService;
}(ODataService));
export { LogService };
